import React, { Component,useRef  } from 'react';
import axios, { AxiosResponse, AxiosInstance } from 'axios';
import swal from 'sweetalert'; 
 
import { API_URL } from '../../config'
import { isEmpty } from '../../config'
//import Modal from 'react-bootstrap/Modal'

 
class PriceUpload extends Component {
 
  constructor(props) {
    super(props);
    this.selectFile = this.selectFile.bind(this);
    this.upload = this.upload.bind(this);
    this.functionThatResetsTheFileInput = this.functionThatResetsTheFileInput.bind(this);
    
    this.state = {
      selectedFiles: undefined,
      currentFile: undefined,
      progress: 0,
      message: "",
      theInputKey:"",
      fileInfos: [],
    };
   

  
   
  }
 

  selectFile(event) {
    this.setState({
      selectedFiles: event.target.files,
    });
    this.setState({
      message:undefined
    });
  }
  upload() {
    if(!isEmpty(this.state.selectedFiles))
    {

          let currentFile = this.state.selectedFiles[0];
          let formData = new FormData();

          var file_ext = currentFile.name.split('.').pop()
          // alert("type : "+currentFile.type)
          // alert("type : "+file_ext)
          if(file_ext !='xls' )
          { 
              // alert("Please Select Excel (xls only) File to uplaod...");
              swal({
                title: "Error!",
                text: "Please Select Excel (xls only) File to uplaod...",
                icon: "warning",
                button: "OK",
            });
              return false;
          }

          formData.append("file", currentFile);
          formData.append("name", "ProductUpload");
          axios({
            method: 'post',
            url: API_URL+'/upload_price/UPloadPricesData',
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
              'authorization': localStorage.getItem('token')
            }  
        }).then((response) => {
          console.log(response);
         let msg=  response.data.data.message;
        
          this.setState({
            message: msg,
             
            selectedFiles: null 
          });
         this.functionThatResetsTheFileInput();
          
        }).catch((err) => {
          this.setState({
            progress: 0,
            message: "Could not upload the file! ---->"+err,
            currentFile: undefined,
          });
          
        }) 
       
    }
    else
    {
      this.setState({
        message:"Please select file"
      });
      alert("Please select file");
    }


  }

  functionThatResetsTheFileInput() 
  {
    let randomString = Math.random().toString(36);
  
    this.setState({
      theInputKey: randomString
    });
  }
  downloadFormat()
  {
    // alert('download format : '+API_URL);

    window.location.href = API_URL+"/upload_price/DownloadExcelFormatForPriceUpload";
  }

  downloadActivePrice()
  { 
    window.location.href = API_URL+"/upload_price/DownloadActivePriceExcel";
  }


     componentDidMount(){  
        
    } 
    render() {
  
      const {
        selectedFiles,
        currentFile,
        progress,
        message,
        fileInfos,
      } = this.state;
  
      return (
          <> 

              <div class="content-overlay"></div>
              <div class="header-navbar-shadow"></div>
              <div class="content-wrapper">
                  <div class="content-header row">
                  </div>
                  <div class="content-body ">
                      <section >
                          <div class="row">
                              <div class="col">
                                  <div class="card px-2 pb-4">
                                      <div class="card-header border-bottom mr-1">
                                          <div class="head-label">
                                              <h4 class="mb-0">Price Upload</h4>
                                          </div>
                                          <div class="dt-action-buttons text-right">
                                              <div class="dt-buttons d-inline-flex">  </div>
                                         </div>
                                        <div class='clear-fix'/>
                                       

                                     </div>
                                     <div>  {/*   Main Code Starts here  */}
                                      
                                     <br></br>   <br></br>
                                     <label className="btn btn-default">
                                          <input type="file"          key={this.state.theInputKey || '' }   onClick={e => (e.target.value = null)} onChange={this.selectFile}  />
                                        </label>

                                        <button
                                          className="btn btn-success" 
                                          onClick={this.upload}
                                        ><i class="fas fa-upload mr-50"></i>
                                          Upload
                                        </button>

                                        <button
                                          className="btn btn-info " style={{paddingLeft:'10px',marginLeft:'20px'}} 
                                          onClick={this.downloadFormat}
                                        > <i class="fas fa-download mr-50"></i>
                                          Download Format
                                        </button>

                                        <button
                                          className="btn btn-warning " style={{paddingLeft:'10px',marginLeft:'20px'}} 
                                          onClick={this.downloadActivePrice}
                                        > <i class="fas fa-download mr-50"></i>
                                          Download Active Price
                                        </button>

                                        <div className="alert alert-danger"  dangerouslySetInnerHTML={{ __html: this.state.message }} style={{paddingLeft:'10px',marginLeft:'20px'}}  >
                                      
                                        </div>
                                      </div>
                                           
                                 </div>  
                                       
                              </div>
                              
                          </div>

                            
                   </section>
                  </div>
              </div>

        </>

      );


  }
}
export default PriceUpload